import * as createTransactions from 'store/actions/transactions/createTransactions';
import * as fetchTransactions from 'store/actions/transactions/fetchTransactions';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import utils from 'helpers/utils';
import { showNotification } from 'store/actions/uiActions';

function* fetchTransactionQuotesAsync({ payload }) {
    try {
        const {
            id,
        } = payload;

        const url = `${ config.getApiBaseUrl() }/transactions/${ id }/quotes`;

        const response = yield apiClient.read(url);

        yield put(fetchTransactions.fetchTransactionQuotesSuccess(response));
    } catch (error) {
        yield put(fetchTransactions.fetchTransactionQuotesFailure(error));
    }
}

function* createTransactionPaymentAsync({ payload }) {
    const {
        transactionId,
        hash,
        redirectUrl,
        onError,
    } = payload;

    try {
        const params = {
            quote_token: hash,
            redirect_url: redirectUrl,
        };

        const url = `${ config.getApiBaseUrl() }/transactions/${ transactionId }/payments`;

        const response = yield apiClient.create(url, params);

        yield put(createTransactions.createTransactionPaymentSuccess(response));
    } catch (error) {
        yield put(createTransactions.createTransactionPaymentFailure(error));

        yield put(showNotification(error.response.message, 'warning'));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

export default function* transactionsSagas() {
    yield [
        takeEvery(types.FETCH_TRANSACTION_QUOTES, fetchTransactionQuotesAsync),
        takeEvery(types.CREATE_TRANSACTION_PAYMENT, createTransactionPaymentAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/transactions/transactionsSagas.js